module.exports = __webpack_public_path__ + "prod/1.42.2/media/logistics.82425e65.mp4";